const data = {
  offer: [
    {
      url: "/uslugi/ulga-podatkowa",
      image: "/foto-1.jpg",
      name: "Ulga podatkowa",
      text: "Sprawdzimy, jakie ulgi Ci przysługują i odzyskamy nadpłacony podatek z Revenue.",
    },
    {
      url: "/uslugi/dla-firm",
      image: "/foto-2.jpg",
      name: "Usługi dla firm",
      text: "Kompleksowa księgowość dla Sole Traderów i spółek LTD: VAT, payroll, roczne rozliczenia.",
    },
    {
      url: "/uslugi/zwrot-z-p60",
      image: "/foto-3.jpg",
      name: "Zwrot podatku z P60",
      text: "Bezpłatnie sprawdzimy, czy należy Ci się zwrot podatku z tytułu zatrudnienia.",
    },
  ],
  info: [
    {
      type: "quote",
      text: `D&M Services: Polskie Biuro Księgowe w Irlandii (Dublin i Cork)`,
    },
    {
      type: "paragraph",
      text: `D&M Accountancy Services to polskie biuro księgowe w Irlandii działające nieprzerwanie od 2008 roku. Od blisko 20 lat wspieramy przedsiębiorców w bezpiecznym prowadzeniu działalności gospodarczej w Irlandii, oferując profesjonalną księgowość w Dublinie, Cork oraz na terenie całego kraju.`,
    },
    {
      type: "paragraph",
      text: `Łączymy doświadczenie tradycyjnego biura rachunkowego z nowoczesnymi rozwiązaniami online. Umożliwiamy elektroniczną wymianę dokumentów, co pozwala naszym klientom oszczędzać czas i koszty oraz wygodnie zarządzać finansami swojej firmy z dowolnego miejsca w Irlandii.`,
    },
    {
      type: "quote",
      text: `Kompleksowa księgowość w Irlandii`,
    },
    {
      type: "paragraph",
      text: `Oferujemy pełną obsługę księgową dla Sole Trader, spółek LTD oraz doradztwo dla osób zatrudnionych na etacie w Irlandii:`,
    },
    {
      type: "paragraph",
      text: `<ul class='about-us-bullets'>
        <li>Rozliczanie VAT w Irlandii</li>
        <li>Rozliczenia podatku dochodowego (Income Tax)</li>
        <li>Rozliczenia Corporation Tax</li>
        <li>Rejestrację działalności gospodarczej w Irlandii</li>
        <li>Zakładanie spółek LTD</li>
        <li>Tworzenie biznesplanów</li>
        <li>Profesjonalne doradztwo biznesowe</li>
        <li>Prowadzenie payroll (kadry i płace, PAYE)</li>
        <li>Roczne rozliczenia podatkowe pracowników</li>
        <li>Zwrot podatku dla osób zatrudnionych</li>
        <li>Doradztwo podatkowe dla osób zatrudnionych</li>
    </ul>`,
    },
    {
      type: "paragraph",
      text: `Nasze usługi księgowe w Dublinie i Cork kierujemy do małych i średnich firm, startupów oraz osób rozpoczynających działalność lub zatrudnienie w Irlandii.`,
    },
    {
      type: "quote",
      text: `Dlaczego warto wybrać D&M Accountancy Services?`,
    },
    {
      type: "paragraph",
      text: `<ul class='about-us-bullets'>
        <li>Ponad 15 lat doświadczenia na rynku irlandzkim</li>
        <li>Setki zadowolonych klientów</li>
        <li>Polski księgowy w Irlandii – obsługa w języku polskim</li>
        <li>Znajomość przepisów Revenue i irlandzkiego systemu podatkowego</li>
        <li>Nowoczesna księgowość online</li>
    </ul>`,
    },
    {
      type: "paragraph",
      text: `Jeśli szukasz sprawdzonego biura księgowego w Irlandii – w Dublinie lub Cork – skontaktuj się z nami i umów bezpłatną konsultację.`,
    },
  ],
}
export default data
